import { fmtCompact } from "../../lib/format";
import type { MonthBar } from "./dashboardData";

// Прогноз cashflow по месяцам. Высота бара пропорциональна сумме за месяц,
// цвет — акцентный для месяцев с погашением (крупные суммы), штрих-паттерн
// для «купонных» месяцев. Сверху — суммарная цифра только для крупных
// баров, чтобы chart не пестрил мелкими подписями.
export function MonthlyForecast({ months }: { months: MonthBar[] }) {
  const max = months.reduce((m, b) => Math.max(m, b.rub), 0);
  const labelThreshold = max * 0.25;

  return (
    <div className="card" style={{ padding: 16 }}>
      <div
        className="row"
        style={{ justifyContent: "space-between", marginBottom: 10 }}
      >
        <div className="serif" style={{ fontSize: 20 }}>
          Прогноз cashflow
        </div>
        <span className="soft" style={{ fontSize: 12 }}>
          12 мес
        </span>
      </div>

      <div className="bars" style={{ height: 160 }}>
        {months.map((b) => {
          const pct = max > 0 ? (b.rub / max) * 100 : 0;
          const small = b.rub > 0 && b.rub < labelThreshold;
          const projPct =
            b.rub > 0 ? Math.min(100, (b.projectedRub / b.rub) * 100) : 0;
          return (
            <div
              key={b.ymKey}
              className={`bar ${b.hasRedemption ? "redeem" : "coupon"} ${b.rub === 0 ? "empty" : ""}`}
              style={{ height: `${Math.max(pct, b.rub > 0 ? 4 : 0)}%` }}
              title={
                b.projectedRub > 0
                  ? `всего +${fmtCompact(b.rub)} ₽ · из них проекция +${fmtCompact(b.projectedRub)} ₽ (ставка ещё не объявлена)`
                  : undefined
              }
            >
              {projPct > 0 && (
                <span
                  className="bar-projected"
                  style={{ height: `${projPct}%` }}
                  aria-hidden
                />
              )}
              {b.rub > 0 && (
                <span
                  className="vlbl"
                  style={small ? { fontSize: 10, opacity: 0.7 } : undefined}
                >
                  {fmtCompact(b.rub)}
                </span>
              )}
              <span className="xlbl">{b.label}</span>
            </div>
          );
        })}
      </div>

      <div className="legend" style={{ marginTop: 12 }}>
        <span>
          <span className="sw redeem" />
          погашение
        </span>
        <span>
          <span className="sw coupon" />
          купон
        </span>
        <span>
          <span className="sw projected" />
          проекция плавающего купона
        </span>
      </div>
    </div>
  );
}
